import { Page } from "components/Page";
import { UserCom } from "features/users/User";

export const UserPage = () => {
  return (
    <Page title="Jaman HP Gas | User">
      <UserCom />
    </Page>
  );
};
